import styled from '@emotion/styled';

import { Breakpoints } from 'utils/const.styles';

export const Container = styled.div`
	display: block;

	position: absolute;
	bottom: 20px;
	height: 100%;
	max-height: 60px;
	max-width: 50%;
	overflow-x: scroll;
	z-index: var(--z-index-8);
	right: 2.5rem;

	body[dir='rtl'] & {
		left: 2.5rem;
		right: auto;
	}

	@media ${Breakpoints.mobile} {
		display: none;
	}

	&.active {
		padding: 1rem;
		background-color: var(--modal-bg-2);
		border: 1px solid var(--border-color);
		border-radius: var(--small-border-radius);
		box-shadow: var(--container-box-shadow);
	}
`;

export const Wrapper = styled.div`
	display: flex;
	flex-direction: row-reverse;
	gap: 1rem;
	justify-content: flex-end;
	align-items: center;
	height: 100%;
	width: fit-content;
`;
